var _path, _polygon, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.17,466.73c0,.14-96.34.26-215.16.26s-215.18-.12-215.18-.26,96.32-.26,215.18-.26S462.17,466.59,462.17,466.73Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.69,447.35S82.14,461,104.6,462s68.7,2.11,68.7,2.11l-2.9-29.33-72-5-11.5,8.46Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 246.36,
    height: 421.74,
    x: 97.7,
    y: 45.19,
    rx: 16,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.27,64.53H330.48a0,0,0,0,1,0,0V450.91a0,0,0,0,1,0,0h-214a5.21,5.21,0,0,1-5.21-5.21V64.53A0,0,0,0,1,111.27,64.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.41,55.32H195.53a2.8,2.8,0,0,1-2.8-2.8h0a2.8,2.8,0,0,1,2.8-2.8h46.88a2.8,2.8,0,0,1,2.8,2.8h0A2.8,2.8,0,0,1,242.41,55.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.16,105.81v2.75h-.22a3,3,0,0,0-1-1.65,2.44,2.44,0,0,0-1.59-.57,2.35,2.35,0,0,0-1.36.42,2.48,2.48,0,0,0-.91,1.12,5,5,0,0,0-.37,2,6.54,6.54,0,0,0,.27,1.94,2.6,2.6,0,0,0,.84,1.33,2.34,2.34,0,0,0,1.49.45,2.86,2.86,0,0,0,1.37-.33,4.8,4.8,0,0,0,1.32-1.13v.68a4.2,4.2,0,0,1-1.39,1,4.24,4.24,0,0,1-1.69.32,4.85,4.85,0,0,1-2.26-.51,3.62,3.62,0,0,1-1.53-1.47,4.13,4.13,0,0,1-.53-2,4.28,4.28,0,0,1,.59-2.16,4.21,4.21,0,0,1,1.61-1.58,4.39,4.39,0,0,1,2.15-.56,5,5,0,0,1,1.77.36,2.7,2.7,0,0,0,.68.21.46.46,0,0,0,.33-.13.81.81,0,0,0,.18-.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.46,106v3.17a3.24,3.24,0,0,1,.83-.67,1.68,1.68,0,0,1,.78-.2,1.34,1.34,0,0,1,.88.3,1.38,1.38,0,0,1,.49.69,5.07,5.07,0,0,1,.12,1.33v2.14a1.71,1.71,0,0,0,.11.78.72.72,0,0,0,.48.2v.21h-2.78v-.21a.64.64,0,0,0,.44-.24,1.56,1.56,0,0,0,.11-.74V110.3a3.53,3.53,0,0,0-.06-.85.5.5,0,0,0-.18-.27.45.45,0,0,0-.28-.1.77.77,0,0,0-.46.17,1.88,1.88,0,0,0-.48.56v2.94a1.76,1.76,0,0,0,.09.73.61.61,0,0,0,.46.25v.21h-2.78v-.21a.69.69,0,0,0,.49-.23,1.55,1.55,0,0,0,.1-.75v-5.57a1.66,1.66,0,0,0-.11-.77.72.72,0,0,0-.48-.2V106Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.92,113.13a2.89,2.89,0,0,1-1.8.88,1.06,1.06,0,0,1-1.09-1.08,1.5,1.5,0,0,1,.54-1.12,10.07,10.07,0,0,1,2.35-1.34v-.55a2.47,2.47,0,0,0-.07-.78.6.6,0,0,0-.25-.28.79.79,0,0,0-.42-.12,1.09,1.09,0,0,0-.63.17.3.3,0,0,0-.15.25.49.49,0,0,0,.16.3.74.74,0,0,1,.22.49.67.67,0,0,1-.21.49.8.8,0,0,1-.56.2.91.91,0,0,1-.62-.23.68.68,0,0,1-.25-.52,1.21,1.21,0,0,1,.34-.8,2.07,2.07,0,0,1,.93-.59,3.71,3.71,0,0,1,1.24-.21,2.09,2.09,0,0,1,1.24.33,1.59,1.59,0,0,1,.58.72,4.27,4.27,0,0,1,.09,1.13v2.13a2.11,2.11,0,0,0,0,.47.31.31,0,0,0,.08.15.23.23,0,0,0,.14,0c.1,0,.2-.07.31-.21l.17.14a2,2,0,0,1-.6.63,1.33,1.33,0,0,1-.71.19,1.11,1.11,0,0,1-.74-.22A1,1,0,0,1,151.92,113.13Zm0-.43v-1.83a3.28,3.28,0,0,0-1,.89,1,1,0,0,0-.23.64.66.66,0,0,0,.19.47.53.53,0,0,0,.41.16A1.12,1.12,0,0,0,151.92,112.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,113.38v2a1.47,1.47,0,0,0,.07.57.45.45,0,0,0,.2.23,1.63,1.63,0,0,0,.56.07v.21h-3.13v-.21a.74.74,0,0,0,.54-.21,1.23,1.23,0,0,0,.12-.7V109.6a1.29,1.29,0,0,0-.14-.74.72.72,0,0,0-.52-.19v-.21H157v.72a2,2,0,0,1,.59-.61,1.69,1.69,0,0,1,.93-.28,1.79,1.79,0,0,1,1.1.38,2.38,2.38,0,0,1,.75,1.06,4,4,0,0,1,.26,1.44,4.11,4.11,0,0,1-.27,1.52,2.29,2.29,0,0,1-.77,1,1.93,1.93,0,0,1-2,.16A2.11,2.11,0,0,1,157,113.38Zm0-.59a1.39,1.39,0,0,0,1.08.71.61.61,0,0,0,.52-.33,6,6,0,0,0,0-3.82.68.68,0,0,0-.6-.34c-.39,0-.72.28-1,.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.75,106.45v2h1.3V109h-1.3v3.38a2.56,2.56,0,0,0,0,.61.44.44,0,0,0,.15.22.37.37,0,0,0,.21.09c.25,0,.49-.19.72-.58l.18.13a1.6,1.6,0,0,1-1.54,1.12,1.34,1.34,0,0,1-.89-.29,1.31,1.31,0,0,1-.46-.64,5.88,5.88,0,0,1,0-1.08v-3h-.72v-.21a7.61,7.61,0,0,0,1.26-1.09,7.06,7.06,0,0,0,.9-1.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.21,111h-3a2.85,2.85,0,0,0,.58,1.72,1.23,1.23,0,0,0,1,.49,1.1,1.1,0,0,0,.63-.2,2.33,2.33,0,0,0,.62-.7l.2.13a3.35,3.35,0,0,1-1,1.28,2.12,2.12,0,0,1-1.24.38,2.07,2.07,0,0,1-1.85-.94,3.26,3.26,0,0,1-.5-1.87,3.07,3.07,0,0,1,.74-2.18,2.25,2.25,0,0,1,1.74-.82,1.88,1.88,0,0,1,1.44.69A3.09,3.09,0,0,1,170.21,111Zm-1.44-.39a5.28,5.28,0,0,0-.11-1.3,1,1,0,0,0-.31-.53.52.52,0,0,0-.33-.11.57.57,0,0,0-.5.3,2.58,2.58,0,0,0-.35,1.43v.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.17,108.46v1.24a4,4,0,0,1,1-1.13,1.49,1.49,0,0,1,.79-.28.69.69,0,0,1,.53.21.77.77,0,0,1,.19.57.89.89,0,0,1-.19.61.59.59,0,0,1-.46.21.79.79,0,0,1-.54-.2l-.26-.22a.32.32,0,0,0-.14,0,.47.47,0,0,0-.32.13,1.19,1.19,0,0,0-.36.56,3.87,3.87,0,0,0-.19,1.26V113a1.57,1.57,0,0,0,0,.42.43.43,0,0,0,.21.23,1.33,1.33,0,0,0,.47.1v.21h-3v-.21a.64.64,0,0,0,.48-.2,1.74,1.74,0,0,0,.13-.88v-3a2.34,2.34,0,0,0,0-.6.44.44,0,0,0-.17-.24.87.87,0,0,0-.39-.11v-.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.51,105.83v6.5a4.35,4.35,0,0,0,.06.93.61.61,0,0,0,.27.33,1.26,1.26,0,0,0,.66.13h.18v.22H179.5v-.22h.21a1.55,1.55,0,0,0,.72-.12.58.58,0,0,0,.3-.32,3.67,3.67,0,0,0,.07-1v-4.12a2.9,2.9,0,0,0-.05-.69.56.56,0,0,0-.2-.24.58.58,0,0,0-.33-.09,1.89,1.89,0,0,0-.72.18l-.11-.21,2.92-1.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.59,157.24v6.43H151a10.14,10.14,0,0,0-1.25-3.2,4.79,4.79,0,0,0-1.87-1.55,6,6,0,0,0-2.33-.32h-1.77v18.33a7.6,7.6,0,0,0,.2,2.27,1.83,1.83,0,0,0,.79.8,3.14,3.14,0,0,0,1.6.34h.79V181H134.68v-.65h.79a3.36,3.36,0,0,0,1.67-.36,1.71,1.71,0,0,0,.71-.84,7.1,7.1,0,0,0,.2-2.21V158.6h-1.72a5,5,0,0,0-3.49,1,6.78,6.78,0,0,0-1.92,4h-.67v-6.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.1,130.84c0,.15-9,.26-20.08.26s-20.08-.11-20.08-.26,9-.26,20.08-.26S305.1,130.7,305.1,130.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,162.07c0,.14-32.77.26-73.19.26s-73.19-.12-73.19-.26,32.76-.26,73.19-.26S304.64,161.92,304.64,162.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,172.13c0,.15-32.77.26-73.19.26s-73.19-.11-73.19-.26,32.76-.26,73.19-.26S304.64,172,304.64,172.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,182.2c0,.15-32.77.26-73.19.26s-73.19-.11-73.19-.26,32.76-.26,73.19-.26S304.64,182.06,304.64,182.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,192.27c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,192.13,304.64,192.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,202.34c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,202.19,304.64,202.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.89,212.41c0,.14-22.15.26-49.46.26s-49.47-.12-49.47-.26,22.14-.27,49.47-.27S227.89,212.26,227.89,212.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,222.47c0,.15-39.33.26-87.84.26s-87.84-.11-87.84-.26,39.32-.26,87.84-.26S304.64,222.33,304.64,222.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,232.54c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,232.4,304.64,232.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,242.61c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,242.46,304.64,242.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,252.68c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,252.53,304.64,252.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,262.74c0,.15-39.33.26-87.84.26s-87.84-.11-87.84-.26,39.32-.26,87.84-.26S304.64,262.6,304.64,262.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.26,272.81c0,.15-6.56.26-14.65.26S129,273,129,272.81s6.55-.26,14.65-.26S158.26,272.67,158.26,272.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,282.88c0,.14-39.33.26-87.84.26S129,283,129,282.88s39.32-.26,87.84-.26S304.64,282.74,304.64,282.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,293c0,.14-39.33.26-87.84.26S129,293.09,129,293s39.32-.26,87.84-.26S304.64,292.8,304.64,293Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,303c0,.15-39.33.26-87.84.26S129,303.16,129,303s39.32-.26,87.84-.26S304.64,302.87,304.64,303Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.82,313.08c0,.15-30.19.26-67.43.26s-67.43-.11-67.43-.26,30.18-.26,67.43-.26S263.82,312.94,263.82,313.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,323.15c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,323,304.64,323.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,333.22c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,333.07,304.64,333.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281,343.29c0,.14-34,.26-76,.26s-76-.12-76-.26,34-.27,76-.27S281,343.14,281,343.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,353.35c0,.15-39.33.26-87.84.26S129,353.5,129,353.35s39.32-.26,87.84-.26S304.64,353.21,304.64,353.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,373.49c0,.14-39.33.26-87.84.26s-87.84-.12-87.84-.26,39.32-.26,87.84-.26S304.64,373.34,304.64,373.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,383.56c0,.14-39.33.26-87.84.26S129,383.7,129,383.56s39.32-.26,87.84-.26S304.64,383.41,304.64,383.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,393.62c0,.15-39.33.26-87.84.26s-87.84-.11-87.84-.26,39.32-.26,87.84-.26S304.64,393.48,304.64,393.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,423.33l-.56,1.53h-4.68v-.22a20.39,20.39,0,0,0,2.91-3.08,3.9,3.9,0,0,0,.84-2.18,1.74,1.74,0,0,0-.46-1.25,1.49,1.49,0,0,0-1.11-.48,1.71,1.71,0,0,0-1.05.34,2,2,0,0,0-.69,1h-.21a2.66,2.66,0,0,1,.75-1.67,2.08,2.08,0,0,1,1.51-.58,2.26,2.26,0,0,1,1.62.62,2,2,0,0,1,.64,1.47,2.77,2.77,0,0,1-.28,1.2,7.66,7.66,0,0,1-1.4,2c-1,1.07-1.58,1.71-1.83,1.93h2.08a5.77,5.77,0,0,0,.89-.05,1.25,1.25,0,0,0,.46-.19,1.31,1.31,0,0,0,.35-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.23,420.93a6.16,6.16,0,0,1,.41-2.34,3.36,3.36,0,0,1,1.09-1.46,1.87,1.87,0,0,1,1.09-.38,2.07,2.07,0,0,1,1.64.93,4.92,4.92,0,0,1,.91,3.13,6.08,6.08,0,0,1-.4,2.35,3,3,0,0,1-1,1.4,2,2,0,0,1-1.2.44,2.21,2.21,0,0,1-1.89-1.34A5.51,5.51,0,0,1,223.23,420.93Zm1.15.15a7.44,7.44,0,0,0,.41,2.68q.33.87,1,.87a1,1,0,0,0,.66-.28,1.82,1.82,0,0,0,.51-1,11.64,11.64,0,0,0,.27-2.85,7.65,7.65,0,0,0-.28-2.26,2.06,2.06,0,0,0-.54-1,.92.92,0,0,0-1.29.17,3,3,0,0,0-.58,1.52A14.59,14.59,0,0,0,224.38,421.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,449.93c-7.44-12.69-23.16-12.83-28.32-2.58V73.62A13.86,13.86,0,0,1,96.54,59.75c4.37-.56,8.34,1.11,15.1,5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,449.93c0-2.75-.72-169.69-1.63-385.16l.13.22a70.69,70.69,0,0,0-6.35-3.33,17.36,17.36,0,0,0-7-1.76,13,13,0,0,0-7,2.1,13.72,13.72,0,0,0-4.85,5.55,14.66,14.66,0,0,0-1.18,3.72,22.15,22.15,0,0,0-.2,3.92q0,4,0,7.92v46.72q0,30.63,0,59.67c0,38.64,0,74.87,0,107.77,0,65.8-.09,118.26-.11,150.08l-.2-.05a13.12,13.12,0,0,1,5.5-5.67A14.53,14.53,0,0,1,96.84,440a17.34,17.34,0,0,1,3.11.25c.49.09,1,.24,1.43.35a8.27,8.27,0,0,1,1.33.43,14.76,14.76,0,0,1,2.37,1.07l1.06.59c.32.21.63.44.93.66a10.8,10.8,0,0,1,1.62,1.29c.47.45.93.84,1.31,1.25a27.3,27.3,0,0,1,1.77,2.17c.79,1.22,1.15,1.76,1.24,1.91l-1.28-1.87c-.42-.64-1.08-1.3-1.79-2.16-.38-.4-.84-.79-1.31-1.23a13,13,0,0,0-1.63-1.28c-.3-.21-.6-.44-.92-.65l-1.06-.57a14.63,14.63,0,0,0-2.36-1.06,7.81,7.81,0,0,0-1.32-.41c-.46-.11-.93-.25-1.41-.35a18.19,18.19,0,0,0-3.09-.23,14.39,14.39,0,0,0-6.65,1.67,12.85,12.85,0,0,0-5.4,5.6l-.2.4v-.44c0-31.82-.06-84.28-.11-150.08,0-32.9,0-69.13,0-107.77q0-29,0-59.67v-31q0-7.83,0-15.74V75.19a22.58,22.58,0,0,1,.22-4,15.08,15.08,0,0,1,1.22-3.86,14.26,14.26,0,0,1,5-5.76,13.51,13.51,0,0,1,7.25-2.18,18,18,0,0,1,7.22,1.8c2.24,1,4.33,2.19,6.39,3.36l.13.08v.15C112.52,280.24,113,447.18,113,449.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.41,273.31a.47.47,0,0,1-.39-.2.5.5,0,0,1,.09-.7l5.68-4.3-5.64-3.58a.49.49,0,0,1-.16-.69.5.5,0,0,1,.69-.16l6.25,4a.47.47,0,0,1,.23.4.49.49,0,0,1-.19.42l-6.25,4.74A.5.5,0,0,1,315.41,273.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.87,64.53v46.12a1.08,1.08,0,0,0,1.84.76l11.11-11.11a1.09,1.09,0,0,1,1.53,0l11.1,11.11a1.08,1.08,0,0,0,1.85-.76V64.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M272.53,64.53v41.86a1.08,1.08,0,0,0,1.85.76l11.11-11.1a1.06,1.06,0,0,1,1.52,0l11.11,11.1a1.08,1.08,0,0,0,1.85-.76V64.53Z",
    style: {
      fill: "#db4437"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.72,128.35c.2-3.56,2.38-5.74,5.45-7.56a11.12,11.12,0,0,1,10.25-.46c2.15,1,4,2.77,6.39,3.07,3.89.5,7.57-3.1,11.39-2.2a5.06,5.06,0,0,1-.37,9.92c2.54.37,4,3.59,3,6s-3.61,3.78-6.18,3.84a14.29,14.29,0,0,1-7.28-2.29c-2.22-1.29-4.3-2.85-6.62-4a11,11,0,0,0-7.48-1.09c-3.36.89-5.75,4.07-6.63,7.44s-.5,6.93,0,10.38,1.19,6.92.86,10.39a1.27,1.27,0,0,1-.48,1.07c-.52.28-1.11-.21-1.49-.66A50.92,50.92,0,0,1,354,144.82c-1.18-3.69-1.83-7.29-.42-10.89s6.17-7.05,9.16-5.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.44,145.53l5.69,35.11c1.06,6.56,5.32,12.9,15.62,10.74h0c8.78-2.54,8.13-8.86,7-16.65h0s9.66-2.52,8.8-12.35c-.42-4.75-2.08-14.47-3.68-23.24a18.38,18.38,0,0,0-19.93-15l-.95.09C361.83,125.89,357.53,135.42,359.44,145.53Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.74,174.73a23.89,23.89,0,0,1-13.17-2.5s3.86,7.31,13.56,5.44Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.93,149a1.41,1.41,0,0,1-1.21,1.55,1.34,1.34,0,0,1-1.57-1.12,1.41,1.41,0,0,1,1.21-1.55A1.35,1.35,0,0,1,390.93,149Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.23,144.17c-.15.2-1.29-.48-2.8-.32s-2.54,1-2.72.85.05-.42.5-.82a3.9,3.9,0,0,1,2.15-.91,3.71,3.71,0,0,1,2.26.49C391.12,143.77,391.31,144.08,391.23,144.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.62,150.33a1.41,1.41,0,0,1-1.21,1.55,1.34,1.34,0,0,1-1.57-1.12,1.41,1.41,0,0,1,1.2-1.55A1.35,1.35,0,0,1,377.62,150.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.43,146c-.16.2-1.3-.48-2.81-.33s-2.54,1-2.72.86.06-.42.5-.82a3.86,3.86,0,0,1,2.16-.91,3.71,3.71,0,0,1,2.26.48C376.31,145.54,376.51,145.86,376.43,146Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,156.59a9.35,9.35,0,0,1,2.41-.69c.38-.08.73-.19.77-.46a1.93,1.93,0,0,0-.37-1.12l-1.43-2.82c-2-4-3.5-7.34-3.33-7.42s1.91,3.12,3.92,7.14l1.38,2.84a2.28,2.28,0,0,1,.36,1.49,1,1,0,0,1-.58.63,2.6,2.6,0,0,1-.65.15A10.19,10.19,0,0,1,383,156.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.22,140c-.1.43-1.63.39-3.38.78s-3.13,1-3.4.67c-.13-.16.08-.57.62-1a5.88,5.88,0,0,1,2.46-1.15,5.76,5.76,0,0,1,2.71.05C375.91,139.5,376.27,139.79,376.22,140Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.24,139.86c-.23.37-1.31.12-2.56.23s-2.28.46-2.56.13c-.13-.16,0-.52.43-.9a3.57,3.57,0,0,1,2-.77,3.52,3.52,0,0,1,2.11.49C390.16,139.35,390.34,139.68,390.24,139.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,152.72c-.17-.06-7-1.32-6.06,5.37s7.43,4.42,7.41,4.22S361,152.72,361,152.72Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.94,160.05s-.1.1-.29.21a1.16,1.16,0,0,1-.87.14A2.94,2.94,0,0,1,357.1,158a4,4,0,0,1,.11-1.71,1.37,1.37,0,0,1,.76-1,.61.61,0,0,1,.73.23c.11.18.09.32.12.32s.13-.13,0-.4a.7.7,0,0,0-.32-.38.89.89,0,0,0-.67-.09,1.67,1.67,0,0,0-1.08,1.2,4.07,4.07,0,0,0-.15,1.92,3.08,3.08,0,0,0,2.08,2.67,1.3,1.3,0,0,0,1-.32C360,160.21,360,160.06,359.94,160.05Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.06,130a13,13,0,0,0-4.6-4.34,22,22,0,0,0-13.15-3.26,17.88,17.88,0,0,0-12,6,18.94,18.94,0,0,0-4.22,10,27.89,27.89,0,0,0,1,10.89,8.4,8.4,0,0,0,2.27,4.2c.76.65,2,1,2.73.32a2.74,2.74,0,0,0,.63-1.63c.77-5.31,1.48-11-.92-15.81a15.56,15.56,0,0,1,4.2-4.71,8,8,0,0,1,6-1.45c3.09.62,5.23,3.35,7.82,5.13a14.24,14.24,0,0,0,12.88,1.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.36,160.66a6.94,6.94,0,0,1-.5,1.85,2.27,2.27,0,0,1-1.39,1.24,2.05,2.05,0,0,1-1.87-.56,3.29,3.29,0,0,1-.86-1.82c-.1-.61,0-1.38.61-1.58a1.63,1.63,0,0,1,.76,0l3.41.62",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.64,163.51a4.55,4.55,0,0,1-1.72.15,2.46,2.46,0,0,1-1.51-.89,2.62,2.62,0,0,1-.47-2.05,2,2,0,0,1,.18-.53c.09-.15.07-.14.21-.15s.36.06.55.09l.56.1c.73.14,1.39.25,1.94.33a5.8,5.8,0,0,0,1.82.16,5.58,5.58,0,0,0-1.74-.56l-1.92-.44-.56-.13a5.51,5.51,0,0,0-.62-.11.74.74,0,0,0-.46.11.77.77,0,0,0-.29.35,2.53,2.53,0,0,0-.23.67,3,3,0,0,0,.62,2.49,2.78,2.78,0,0,0,1.87,1,2.58,2.58,0,0,0,1.37-.23C383.54,163.68,383.66,163.54,383.64,163.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.44,122.57a1.71,1.71,0,0,1,.13.44,4.35,4.35,0,0,1,.05,1.32,6.18,6.18,0,0,1-2.43,4.11,9.18,9.18,0,0,1-6.93,1.42c-2.72-.37-5.44-1.68-8.28-2.85s-5.75-2-8.36-1.48a10.61,10.61,0,0,0-6,3.42,14.31,14.31,0,0,0-2.55,4c-.42,1-.57,1.65-.62,1.64a2.48,2.48,0,0,1,.09-.45,10.74,10.74,0,0,1,.38-1.25,13.24,13.24,0,0,1,2.47-4.14,10.72,10.72,0,0,1,6.13-3.6c2.73-.52,5.75.29,8.6,1.47s5.53,2.47,8.17,2.85a8.89,8.89,0,0,0,6.68-1.27,6.14,6.14,0,0,0,2.45-3.89A7.24,7.24,0,0,0,398.44,122.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.5,143a4.84,4.84,0,0,1,.26-1.85,11.7,11.7,0,0,1,2-4,11.88,11.88,0,0,1,1.74-1.79,4.31,4.31,0,0,1,1.84-1,2.21,2.21,0,0,1,1.4.15c.3.16.41.31.39.33a2.59,2.59,0,0,0-1.72-.18,7.58,7.58,0,0,0-3.3,2.72,13.44,13.44,0,0,0-2.08,3.85C354.68,142.26,354.57,143,354.5,143Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.27,148.74a5.56,5.56,0,0,1,.38-1.84,12.61,12.61,0,0,1,2.24-4,12.39,12.39,0,0,1,3.5-2.9,5.45,5.45,0,0,1,1.75-.7c0,.07-.63.36-1.59,1a14.28,14.28,0,0,0-5.61,6.7A15.18,15.18,0,0,1,356.27,148.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.75,424l15.32,20.14,7.52,19.43a2.6,2.6,0,0,0,3.52,1.41h0a2.58,2.58,0,0,0,1.45-1.88c.95-5.26,4.36-24.65,3.16-26.06-1.4-1.64-14.75-22.32-14.75-22.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442.11,465l3.6-29.33.63.87a3.88,3.88,0,0,1,.74,2.59c-.19,2.48-.87,9.29-3.46,23.95a2.6,2.6,0,0,1-1.51,1.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M436.72,432.11a1.56,1.56,0,0,0,.85,1.91,1.49,1.49,0,0,0,1.9-.83,1.66,1.66,0,0,0-.91-2,1.56,1.56,0,0,0-1.88,1.09",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.3,452.65a5.6,5.6,0,0,0-5.64,1c-.05,0,.09-.38.52-.8a4.14,4.14,0,0,1,2.08-1,4.08,4.08,0,0,1,2.29.26C440.09,452.32,440.34,452.6,440.3,452.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.83,456.45a20.88,20.88,0,0,0-2.45.44c-1.29.44-2.06,1.3-2.19,1.19s.54-1.21,2-1.72A2.89,2.89,0,0,1,440.83,456.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.47,447.17a24.11,24.11,0,0,0-3.83.41,25.84,25.84,0,0,0-3.56,1.5,7.07,7.07,0,0,1,7.39-1.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.32,440.65c0,.17-1.44.51-2.95,1.53s-2.42,2.21-2.56,2.12a6.47,6.47,0,0,1,5.51-3.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,434.63a12.18,12.18,0,0,0-3.12,1.5,12.5,12.5,0,0,0-2.22,2.66c-.07,0,0-.44.25-1.06a5.61,5.61,0,0,1,4-3.12C431.56,434.49,432,434.56,432,434.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.07,435s-.27-.22-.59-.75a6.66,6.66,0,0,1-.86-2.48,3,3,0,0,1,.2-1.88,1,1,0,0,1,1.09-.5,1.69,1.69,0,0,1,1,.69,3.66,3.66,0,0,1-.61,4.63,4.27,4.27,0,0,1-4.69.65,1.49,1.49,0,0,1-.77-.95,1,1,0,0,1,.55-1.07,3.62,3.62,0,0,1,1.85-.28,7.63,7.63,0,0,1,2.56.58,2.39,2.39,0,0,1,.83.48,12.07,12.07,0,0,0-3.4-.66,3.29,3.29,0,0,0-1.61.28.54.54,0,0,0-.3.58,1,1,0,0,0,.55.59,3.76,3.76,0,0,0,4.05-.61,3.18,3.18,0,0,0,.58-3.92,1.18,1.18,0,0,0-.68-.51.55.55,0,0,0-.6.27,2.67,2.67,0,0,0-.2,1.59A9.53,9.53,0,0,0,428.07,435Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.33,433.66l-3,20.42s19.89,8.39,19.7,12.22l-39.93-2.87,3.34-32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.23,451a1.64,1.64,0,0,0-1.32,1.74,1.57,1.57,0,0,0,1.7,1.33,1.74,1.74,0,0,0,1.4-1.85,1.64,1.64,0,0,0-1.93-1.18",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.12,463.43l.34-3.23,38.46,4.12a2.74,2.74,0,0,1,1.31,2.28Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399,453.94c0,.2-1,.18-2,.7s-1.62,1.28-1.79,1.18.24-1.18,1.49-1.79S399.08,453.77,399,453.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,456.13c0,.19-.86.43-1.6,1.18s-1,1.6-1.23,1.57-.2-1.15.75-2.06S403,455.94,403,456.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.82,461.38c-.18,0-.34-1,.27-2s1.57-1.34,1.64-1.17-.56.68-1.06,1.52S405,461.38,404.82,461.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.18,449.22c-.1.17-1-.2-2.07-.25s-2,.21-2.08,0,.81-.78,2.11-.71S399.29,449.07,399.18,449.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "400.73 437.7 400.21 441.34 380.67 439.02 381.01 435.73 400.73 437.7"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M399.7,445.09a3.83,3.83,0,0,1-2-.23,8.79,8.79,0,0,1-2-.87,9.77,9.77,0,0,1-1.08-.73,2.31,2.31,0,0,1-.55-.54.86.86,0,0,1,0-1,1.08,1.08,0,0,1,.9-.35,2.77,2.77,0,0,1,.74.18,7.69,7.69,0,0,1,1.19.56,7.39,7.39,0,0,1,1.71,1.41c.83,1,1.06,1.72,1,1.75s-.48-.6-1.34-1.41a7.9,7.9,0,0,0-1.67-1.2,8.48,8.48,0,0,0-1.1-.48c-.41-.15-.77-.2-.9,0s-.05.09,0,.23a2.23,2.23,0,0,0,.41.39,10.05,10.05,0,0,0,1,.71,11.26,11.26,0,0,0,1.85.95A13.26,13.26,0,0,1,399.7,445.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.42,445.34a3.22,3.22,0,0,1-.31-2,6.39,6.39,0,0,1,.51-2.16,6,6,0,0,1,.64-1.15,1.64,1.64,0,0,1,1.38-.87.94.94,0,0,1,.77.65,2.71,2.71,0,0,1,.12.75,4.15,4.15,0,0,1-.14,1.34,4.58,4.58,0,0,1-1.08,2c-.89.95-1.73,1.09-1.73,1s.66-.4,1.36-1.33a4.63,4.63,0,0,0,.84-1.8,4,4,0,0,0,.09-1.16c0-.43-.14-.79-.3-.76s-.57.26-.77.58a6.39,6.39,0,0,0-.61,1,7.46,7.46,0,0,0-.61,2C399.4,444.57,399.53,445.32,399.42,445.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.79,263.77s9.42,18.07,9.42,32.69c0,3.09-19.12,156.47-19.12,156.47l-27-2.28,13.12-141.71-4.25-28.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.54,279.78s6.32,52.81,9.29,73.16c3.11,21.3,9.21,25.32,9.21,25.32L426,446.45l17.72-15.71L397.25,361s-9.84-83.27-9.44-81.21S353.54,279.78,353.54,279.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,379.14a3.45,3.45,0,0,0,.45.66l1.4,1.8,5.13,6.61,16.77,22c6.53,8.58,12.49,16.33,16.9,21.86,2.2,2.77,4,5,5.28,6.5l1.47,1.74a5.13,5.13,0,0,0,.54.58,3.46,3.46,0,0,0-.46-.65c-.35-.46-.81-1.06-1.39-1.8L414,431.78c-4.33-5.66-10.24-13.4-16.77-22S384.7,393.5,380.29,388c-2.2-2.77-4-5-5.28-6.51l-1.47-1.73A4.85,4.85,0,0,0,373,379.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.34,310.7a.73.73,0,0,0,0,.24l.06.7q.09,1,.27,2.7c.26,2.38.62,5.76,1.08,9.91,1,8.4,2.3,19.93,3.76,32.67.17,1.4.33,2.79.49,4.09v.07l0,.05,16.7,25.06c2.11,3.14,3.82,5.67,5,7.46.58.85,1.05,1.51,1.38,2l.37.52c.09.11.13.17.14.16a.78.78,0,0,0-.1-.19l-.33-.54-1.3-2.05L414,386l-16.57-25.16,0,.11c-.15-1.31-.32-2.7-.48-4.1-1.53-12.73-2.91-24.26-3.91-32.65-.53-4.15-.95-7.52-1.25-9.9-.15-1.13-.27-2-.36-2.68-.05-.28-.08-.51-.11-.7S391.35,310.69,391.34,310.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M356,299.78s21,5.53,35.36,3.23c20.31-3.23,31.42-12.52,31.42-12.52l-1.81-5.8L355.13,293Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M389,179.8l16,4.6s9.45,67.28,11.79,77.1c2.94,12.31,6.25,22,6,25.46,0,0-7.29,9.67-28.78,12.2S352,295.68,352,295.68l-1.76-40.37s-9.92-36.14-10.13-42.17c-.54-14.82,3.06-23.45,3.06-23.45l21.4-9.59C370.53,186.76,385.82,189,389,179.8Z",
    style: {
      fill: "#db4437"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.67,196.74A23,23,0,0,0,405,184.4l1.37,33.82,8.84,11.05-8.84,6,14.85,19.27s14.23-6.68,14.86-12.68S421,202,418.67,196.74Z",
    style: {
      fill: "#db4437"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.92,234l-3.62,12.57c12.49,14.81,46.9,7.94,46.9,7.94l-13.69-19.34C400.41,237.52,377.92,234,377.92,234Z",
    style: {
      fill: "#db4437"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.87,232.21s-6.42-12.65-7.11-12.8-10.79-3.7-10.79-3.7a3.64,3.64,0,0,0,0,2.54l-3.62.46s.54,2.24,1.77,2.55l-1.31,1.15a7.26,7.26,0,0,0,2.47,2.09,2.7,2.7,0,0,0,2.39,0s-.47.84,1.61,2.15,6.28,7.39,6.28,7.39Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.29,218.29a44.88,44.88,0,0,0,6.61,2.58c.92.33,1.84.58,2.56.92a3.52,3.52,0,0,1,1.51,1.44c.6,1.09.83,1.88.92,1.84a4.74,4.74,0,0,0-.58-2,3.66,3.66,0,0,0-1.62-1.71,24.06,24.06,0,0,0-2.61-1A46.62,46.62,0,0,0,357.29,218.29Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.94,221.26a5.1,5.1,0,0,0,1.82.67c1.16.31,2.79.57,4.52,1a11.73,11.73,0,0,1,4.09,1.92c.92.72,1.33,1.34,1.41,1.29a3.43,3.43,0,0,0-1.16-1.58,10.1,10.1,0,0,0-4.19-2.16c-1.78-.48-3.42-.68-4.59-.89A10.31,10.31,0,0,0,354.94,221.26Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.19,226.59a5.83,5.83,0,0,0-5.33-1.9c0,.16,1.27.25,2.73.78S364.09,226.72,364.19,226.59Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.06,189.86c4.57,1.12,5.92,6.49,9.08,17.23s6.63,21.8,6.63,21.8l1.79,5.15,39.8-9.61,8.05,12.75s-25.88,20.56-44.49,21.38c-9.06-.84-15-4.24-22.35-16.46-4.18-6.9-6.92-13.3-8.16-19.53-1.73-8.69-4.63-17.19-2.19-25.41C339.13,190.7,342.53,188.26,349.06,189.86Z",
    style: {
      fill: "#db4437"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48,215.3a27.57,27.57,0,0,0-.85-5.36,26.49,26.49,0,0,0-1.39-5.25,28.52,28.52,0,0,0,.85,5.36A27,27,0,0,0,407.48,215.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M379.37,256.83a34.38,34.38,0,0,1,7.21-2.09c2.65-.4,4.88.39,7.53.8,7.91,1.24,13.81.3,21.27,0l.41,2.29c-3.28,2.56-7.41,3.38-11.58,3.3-3.77-.07-7.48-1.3-11.26-1.19a38.82,38.82,0,0,0-8.74,1.75A36.58,36.58,0,0,1,369.45,263c-12.37-1.86-17.14-11.59-19.2-16.12a37.66,37.66,0,0,0,3.42,4.68C361.54,259.73,372.84,259.58,379.37,256.83Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M415.79,237.29a1.37,1.37,0,0,1-.19.17l-.58.45c-.52.4-1.29,1-2.3,1.68-2,1.43-5,3.43-8.73,5.74a140.23,140.23,0,0,1-13.62,7.43c-1.32.62-2.67,1.27-4.1,1.82l-2.15.88c-.73.28-1.48.53-2.23.79a49.26,49.26,0,0,1-9.57,2.37,32.58,32.58,0,0,1-5,.13,18.48,18.48,0,0,1-4.76-1.13,23.51,23.51,0,0,1-7.69-5,47,47,0,0,1-8.95-12.66,74.29,74.29,0,0,1-4-9.65c-.4-1.17-.67-2.09-.84-2.72q-.1-.44-.18-.72a.66.66,0,0,1,0-.25.91.91,0,0,1,.09.24l.23.7c.21.62.51,1.52.93,2.68a79.81,79.81,0,0,0,4.15,9.56,47.43,47.43,0,0,0,8.95,12.47,23.1,23.1,0,0,0,7.54,4.89,17.48,17.48,0,0,0,4.63,1.09,31.27,31.27,0,0,0,4.92-.13,49.67,49.67,0,0,0,9.47-2.33l2.21-.78,2.14-.87c1.42-.55,2.77-1.18,4.09-1.79A149.08,149.08,0,0,0,403.8,245c3.77-2.27,6.76-4.22,8.8-5.6l2.36-1.59.61-.41C415.71,237.33,415.78,237.28,415.79,237.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.08,202.31a2.78,2.78,0,0,0,.14.65c.13.46.3,1.07.5,1.83l1.94,6.76c1.7,5.76,4,13.67,6.66,22.56l.07.23.26-.07c.93-.23,2-.46,3.1-.69,9.81-2.1,18.66-4.15,25-5.83,3.18-.82,5.74-1.57,7.5-2.1l2-.65a4.74,4.74,0,0,0,.69-.25,3.07,3.07,0,0,0-.72.16l-2,.55c-1.78.47-4.35,1.16-7.54,1.94-6.37,1.59-15.23,3.58-25,5.68-1.09.24-2.11.45-3.17.72l.33.16L360,211.45c-.87-2.81-1.58-5.08-2.09-6.71-.24-.75-.44-1.35-.59-1.81A2.86,2.86,0,0,0,357.08,202.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.72,234.2l17.09-.31a4,4,0,0,0,3.7-2.74l10-30.28c.75-2.28-.93-4.13-3.63-4.28l-20.92-1.18c-3.36,0-5.15,1.05-5.72,3l-6.53,23.85C410,227.76,412.78,234,417.72,234.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.57,222.66l2.73-5.79,5.05-1.42-1.61,5.33c1.76.86,4.09,1.41,5.61.57s7.49-6.77,8.62-6.2,2.13,1.93,1.1,3.23-6.62,5.34-5.47,6.53,7.6-4,9.49-3.65,3.05,1.49,2,2.3-3.65,3.4-4.11,4.54c.11,1.42.79,3.44.17,3.79a23,23,0,0,1-4.75,1.64c-.34,0-2.74,1-4.95,1.85a11,11,0,0,1-7.78.18l-1.28-.45a5,5,0,0,1-3.33-4.74l.05-4.27Z",
    style: {
      fill: "#ffbf9d"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.3662e115cc958c63785abb581c2dd579.svg";
export { ForwardRef as ReactComponent };